<i18n>
{
  "no": {
    "title": "Connect Device",
    "userCode": "Bekreftelseskode (9 siffer)",
    "infoMessage": "Skriv in koden som visas på din enhet. Fortsett bare hvis di øverenstemmer",
    "maintenance": {
      "header": "Vedlikehold",
      "text": "Innlogging vil være utilgjengelig mens vi jobber med vedlikehold på våre digitale tjenester. Vi beklager eventuelle ulemper dette måtte medføre"
    }
  },
  "en": {
    "title": "Connect Device",
    "userCode": "Verification code (9 digits)",
    "infoMessage": "Enter the code displayed on your device",
    "maintenance": {
      "header": "Maintenance",
      "text": "Login will be unavailable while we work on maintenance of our digital services. We apologize for any inconvenience this may cause"
    }
  }
}
</i18n>

<template>
  <div v-if="!isMaintenance" class="page">
    <FormWrapper>
      <div>
        <TnHeading type="h1" size="s" align="center" class="margin-vertical-2xl">
          {{ t('title') }}
        </TnHeading>

        <form action="/device/activate" method="get" class="narrow-form">
          <TnTextField
            v-model="userCode"
            name="userCode"
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="9"
            pattern="[0-9]*"
            :label="t('userCode')"
            :description="t('infoMessage')"
          />

          <TnButton
            type="submit"
            primary
            block
            class="margin-top-l"
            icon-right="cta-right"
            :disabled="disabledButton"
          />
        </form>
      </div>
    </FormWrapper>
  </div>

  <div v-else class="page">
    <TnHeading type="h1" size="m" align="center" class="margin-vertical-2xl">
      {{ t('maintenance.header') }}
    </TnHeading>
    <TnNotificationInline horizontal status="warning" full-width>
      {{ t('maintenance.text') }}
    </TnNotificationInline>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import {
  TnButton,
  TnHeading,
  TnNotificationInline,
  TnTextField,
} from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from '@/components/FormWrapper.vue';
import { EnvironmentService } from '@/environment';

// The maintenance.* keys were referenced but missing from this component's
// i18n block (and from the global messages), so they rendered as raw paths.
const { t } = useI18n();
const route = useRoute();

const environment = ref<Record<string, string>>({});
const userCode = ref<string>((route.query.userCode as string) ?? '');

const isMaintenance = computed(() => environment.value.maintenance === 'true');
const disabledButton = computed(() => !userCode.value || userCode.value.length === 0);

onMounted(async () => {
  environment.value = await EnvironmentService.getEnvironment();
});
</script>

<style scoped>
.narrow-form {
  max-width: 430px;
  margin-inline: auto;
}
</style>
